module.exports = __webpack_public_path__ + "img/LA.1142ac84.svg";